import React from "react";
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  Container,
  Link,
  Icon,
} from "@chakra-ui/react";
import { FiHome } from "react-icons/fi";
import { ImWarning } from "react-icons/im";
import { isArray } from "lodash";
import { PAYMENT_ERROR } from "@picovico/ui/constant/alertMessage";

function PaymentError({
  message = PAYMENT_ERROR,
  supportEmail = "support@sageflick.com",
}: {
  message?: string | string[];
  supportEmail?: string;
}) {
  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" pt={4}>
      <Container maxW="md" bg="white" borderRadius="lg" boxShadow="lg" p={8}>
        <VStack spacing={6} textAlign="center">
          {/* Error Icon */}
          <Box bg="red.100" p={4} borderRadius="full" display="inline-flex">
            <Icon as={ImWarning} boxSize={12} color="red.600" />
          </Box>

          {/* Error Message */}
          <VStack spacing={3}>
            <Heading as="h1" size="xl" color="gray.900">
              Payment Failed
            </Heading>
            {isArray(message) ? (
              message.map((item) => <Text key={item}>{item}</Text>)
            ) : (
              <Text>{message}</Text>
            )}
          </VStack>

          {/* Action Button */}
          <Button
            colorScheme="primary"
            size="lg"
            width="full"
            leftIcon={<FiHome />}
            onClick={handleGoHome}
            _hover={{
              transform: "translateY(-1px)",
              boxShadow: "lg",
            }}
            transition="all 0.2s"
          >
            Go to Home Page
          </Button>

          {/* Support Information */}
          <Box pt={4} borderTop="1px" borderColor="gray.200" width="full">
            <Text fontSize="sm" color="gray.500">
              Need help? Contact our support team at{" "}
              <Link
                href={`mailto:${supportEmail}`}
                color="blue.600"
                textDecoration="underline"
                _hover={{ color: "blue.700" }}
              >
                {supportEmail}
              </Link>
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}

export default PaymentError;
